import type { Alpha3Code } from 'i18n-iso-countries'

export type GivingCampaignOverviewDto = {
  id: string
  title: string
  shortDescription: string
  coverImage: string
}

export type GivingCampaignPartnerDto = {
  id: string
  title: string
  startDate: string | null
  endDate: string | null
  createdAt: string
  status: GivingCampaignStatusDto
  groups: { id: string; name: string }[]
}

export type GivingCampaignGroupDto = {
  id: string
  name: string
}

export type GetGivingCampaignsForAccountResponse = {
  data: GivingCampaignOverviewDto[]
}

export const enum GivingCampaignStatusDto {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  CANCELLED = 'CANCELLED'
}

export type GivingCampaignDto = {
  id: string
  title: string
  status: GivingCampaignStatusDto
  shortDescription: string
  description: string
  coverImage: string
  startDate: string | null
  endDate: string | null
  groupIds: string[]
  createdAt: string
  targetCountries?: Alpha3Code[]
}

export type GetGivingCampaignResponse = {
  data: GivingCampaignDto
}
